import React, { useEffect, useState } from 'react';
import { Col, Container, ProgressBar, Row, Spinner } from 'react-bootstrap';
import { getProtectedData } from '../services/api';
import { getCurrentPeriod, isEmpty } from '../helper/utils';
import "./FacilityParticipation.css";
import ReactSlider from 'react-slider';

// TODO: get facility coordinates, live status from backend and only show those
const facilities = [
  {
    id: 1,
    name: "MRWPS",
    status: "Active",
    load: "High",
  },
  {
    id: 2,
    name: "CWRP",
    status: "Inactive",
    load: "Medium",
  },
  {
    id: 3,
    name: "Test Facility",
    status: "Active",
    load: "Low",
  },
  {
    id: 4,
    name: "HVPS",
    status: "Active",
    load: "High",
  },
  {
    id: 5,
    name: "MBS",
    status: "Active",
    load: "Medium",
  },
  {
    id: 6,
    name: "ORQ",
    status: "Inactive",
    load: "Low",
  },
  {
    id: 7,
    name: "LSPS",
    status: "Active",
    load: "Medium",
  },
];

const FacilityParticipation = () => {
  const [participationData, setParticipationData] = useState(null);
  const [availabilityData, setAvailabilityData] = useState(null);
  const [facilityData, setFacilityData] = useState(null);
  const [sliderPeriod, setSliderPeriod] = useState(getCurrentPeriod());
  const [refresh, setRefresh] = useState(true);
  const [loaded, setLoaded] = useState(false);

  // Data loading START
  const processParticipationData = (data) => {
    const participationDataMap = {};
    facilities.forEach(facility => {
      participationDataMap[facility.name] = data
        .filter(entry => entry.facility_name_dph_id === facility.name)
        .sort((a, b) => a.period_dph - b.period_dph);
    });
    setParticipationData(participationDataMap);
  };

  // Helper function for processFacilityData
  const combineData = (data1, data2) => {
    const combined = [...data1];
    data2.forEach(item2 => {
      const matchingItem = combined.find(item1 => item1.period === item2.period && item1.time === item2.time);
      if (matchingItem) {
        matchingItem.power_kw_field += item2.power_kw_field;
      } else {
        combined.push(item2);
      }
    });
    return combined;
  };

  const processFacilityData = (data) => {
    if (data.hasOwnProperty("cwrpeast") || data.hasOwnProperty("cwrpwest")) {
      data.cwrp = combineData(
        isEmpty(data.cwrpeast) ? [] : data.cwrpeast,
        isEmpty(data.cwrpwest) ? [] : data.cwrpwest
      );
      if (data.hasOwnProperty("cwrpeast")) { delete data.cwrpeast; }
      if (data.hasOwnProperty("cwrpwest")) { delete data.cwrpwest; }
    }
    setFacilityData(data);
  }

  useEffect(() => {
    setLoaded(false);
    (async () => {
      await Promise.all([
        getProtectedData("/getFacilityParticipation", [], processParticipationData, setParticipationData({})),
        getProtectedData("/getAvailability", {}, setAvailabilityData, setAvailabilityData({})),
        getProtectedData("/getFacilityData", {}, processFacilityData, setFacilityData({})),
      ]);
    })();
    const interval = setInterval(() => setRefresh((r) => !r), 10 * 1000); // Update data every 10 sec
    setLoaded(true);
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [refresh]);
  // Data loading END

  // Data processing START
  const getFacilityPower = (facilityName, period=sliderPeriod) => {
    if (isEmpty(facilityData[facilityName])) { return 0; }
    const currentPeriodData = facilityData[facilityName].filter((periodData) => periodData.period == period);
    return isEmpty(currentPeriodData) ? 0 :
      Math.round(currentPeriodData.reduce((total, periodData) => (
        periodData && periodData.hasOwnProperty("power_kw_field") ? periodData.power_kw_field + total : total),
        0
      ) / currentPeriodData.length);
  }

  const getParsedFacilityName = (facilityName) => Object.keys(participationData).find(name => name.toLowerCase() == facilityName.toLowerCase());

  const getFacilityParticipationChart = (facilityName) => {
    const parsedFacilityName = getParsedFacilityName(facilityName);
    if (!parsedFacilityName || isEmpty(participationData[parsedFacilityName])) {
      return <ProgressBar variant='secondary' now={100} style={{height: 30}} />;
    }
    return (
      <ProgressBar style={{height: 30}}>
        {
          [...Array(48).keys()].map(i => i+1)
            .reduce((arr, period) => {
              const data = participationData[parsedFacilityName].find(x => x.period_dph == period);
              const currentLoad = data && data.curtailed_load ? data.curtailed_load : 0;
              if (period > 1) {
                const prev = arr[arr.length-1];
                if (prev.load == currentLoad) {
                  return [...arr.slice(0, -1), { len: prev.len+1, load: currentLoad }];
                }
                return [...arr, { len: 1, load: currentLoad }];
              }
              return [{ len: 1, load: currentLoad }];
            }, [])
            .map((barInfo, idx) =>
              <ProgressBar
                variant={barInfo.load > 0 ? "success" : "secondary"}
                now={100/48*barInfo.len}
                key={idx}
                label={barInfo.load > 0 ? barInfo.load : null}
              />
            )
        }
      </ProgressBar>
    );
  }

  const getFacilityStatusJsx = (facilityName) => {
    const statusNotFound = (<p className='text-center m-0'>-</p>);

    const parsedFacilityName = getParsedFacilityName(facilityName);
    console.log(parsedFacilityName)
    console.log(participationData)
    if (!parsedFacilityName || isEmpty(participationData[parsedFacilityName])) {
      return statusNotFound;
    }


    const currentPeriodData = participationData[parsedFacilityName].sort((a, b) => a.period_dph - b.period_dph)[0];
    const statuses = {
      submittedisscheduled: 'Scheduled',
      isSubmission_ack: 'Bid acknowledged',
      isSubmission: 'Bid submitted',
      submittedload: 'Load submitted',
      requested: 'Requested',
    };
    const statusKey = Object.keys(statuses).find((key) => currentPeriodData[key]);
    if (!statusKey) { return statusNotFound; }
    const currentStepNumber = Object.keys(statuses).findIndex(key => key == statusKey);
    const totalSteps = Object.keys(statuses).length;
    const progress = Math.round(currentStepNumber/totalSteps*100);
    let statusLabel = statuses[statusKey];
    if (currentPeriodData.isScheduled === 'Scheduled') {
      statusLabel = currentPeriodData.partial_cl > 0 ? 'Partially Scheduled' : 'Scheduled';
    } else {
      statusLabel = 'Unscheduled';
    }
    return (
      <Container fluid className='h-100 p-0 d-flex flex-column justify-content-center align-items-start'>
        <p className='m-0'>{`${statusLabel} (${currentStepNumber}/${totalSteps})`}</p>
        <ProgressBar animated now={progress} style={{height: "5px"}} className='w-100' />
      </Container>
    );
  };
  // Data processing END

  return loaded && participationData !== null && availabilityData !== null && facilityData !== null ? (
    <Container fluid className="h-100 p-0 d-flex flex-column">
      <Container fluid className="pt-2 d-flex flex-row justify-content-evenly align-items-center">
        <Container className="w-25 h-100 p-0 position-relative">
          <label id="slider-label">Select Period:</label>
          <ReactSlider
              className="horizontal-slider"
              marks
              markClassName="example-mark"
              min={1}
              max={48}
              thumbClassName="example-thumb"
              trackClassName="example-track"
              renderThumb={(props, state) => <div {...props}>{state.valueNow}</div>}
              onChange={setSliderPeriod}
              defaultValue={sliderPeriod}
          />
        </Container>
        {["total_load", "curtailed_load"].map(key => (
          <Container className="w-25 h-100 p-0" key={key}>
            <h1 className='m-0 text-center'>{
              isEmpty(participationData) ? "-" :
                Math.round(Object.values(participationData).reduce((total, allPeriodsData) => {
                  const currentPeriodData = allPeriodsData.find((periodData) => periodData.period_dph == sliderPeriod);
                  return currentPeriodData && currentPeriodData.hasOwnProperty(key) ?
                    currentPeriodData[key] + total : total;
                }, 0))
            } kW</h1>
            <p className='m-0 text-center'>
              {key.split("_").map(val => val[0].toUpperCase() + val.slice(1)).join(" ")}
            </p>
          </Container>
        ))}
        <Container className="w-25 h-100 p-0">
          <h1 className='m-0 text-center'>{
            isEmpty(facilityData) ? "-" :
              Math.round(Object.keys(facilityData)
                .reduce((total, facilityName) => getFacilityPower(facilityName) + total, 0))
          } kW</h1>
          <p className='m-0 text-center'>Total Power</p>
        </Container>
      </Container>
      <Container fluid className="pt-2 flex-grow-1 overflow-hidden">
        <Row className="table-header">
          <Col md={1} className='p-1'>Facility</Col>
          <Col md={1} className='p-1'>Power (kW)</Col>
          <Col md={8} className='p-1'>
            <Container fluid className='h-100 p-0 d-flex flex-column justify-content-center align-items-middle border-0'>
              <p className='fw-bold text-center m-0'>Availability</p>
              <ProgressBar style={{height: 20}}>
                {
                  [...Array(48).keys()].map(i => i+1).map((period) =>
                    <ProgressBar variant="info" now={100/48} label={period} key={period} />
                  )
                }
              </ProgressBar>
            </Container>
          </Col>
          <Col md={2} className='p-1'>Status</Col>
        </Row>
        <Row className='overflow-auto'>
          {
            Object.keys(facilityData).map(facility => (
              <>
                <Col md={1} className='p-1 border'>
                  <p className='text-center m-0'>{getParsedFacilityName(facility)}</p>
                </Col>
                <Col md={1} className='p-1 border'>
                  <p className='text-center m-0'>{getFacilityPower(facility)}</p>
                </Col>
                <Col md={8} className='p-1 border'>
                  <Container fluid className='h-100 p-0 d-flex flex-column justify-content-center align-items-middle'>
                    {getFacilityParticipationChart(facility)}
                  </Container>
                </Col>
                <Col md={2} className='p-1 border'>
                  {getFacilityStatusJsx(facility)}
                </Col>
              </>
            ))
          }
        </Row>
      </Container>
    </Container>
  ) : <Spinner animation="border" variant="primary" />;
};

export default FacilityParticipation;
